import React, { useEffect } from "react";
import { Card, Row, Col, Badge } from "react-bootstrap";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
    getDashboardAudits,
    getDashboardIssues,
    getDashboardAlerts
} from "../../store/actions/Dashboard";
import "./Dashboard.css";
import DashboardAlertCard from "./DashboardAlertCard";
import ComputerPage from "../Computer/ComputerPage";

const Dashboard = ({
    audits,
    issues,
    alerts,
    getDashboardAudits,
    getDashboardIssues,
    getDashboardAlerts,
    isAdmin
}) => {
     const navigate = useNavigate();

    useEffect(() => {

        getDashboardAudits();

        getDashboardIssues();

        getDashboardAlerts();

    }, [
        getDashboardAudits,
        getDashboardIssues,
        getDashboardAlerts,
        isAdmin
        
    ]);
     
   

    return (
        
        <div className="dashboard-container">
            {isAdmin ? (
            <>

            <Row className="g-4">

            {/* =====================================================
                LEFT COLUMN
                AUDITS + ISSUES
            ====================================================== */}

            <Col lg={6}>

                {/* ================= AUDITS ================= */}
                
                <Card className="dashboard-panel audit-panel">

                    <Card.Header className="dashboard-panel-header">

                        <div className="dashboard-title">

                            <div className="dashboard-title-icon audit-icon">
                                <i className="bi bi-shield-check"></i>
                            </div>

                            <div>
                                <h5>Audits</h5>
                            </div>

                        </div>

                        {/* <Badge bg="calm" className="count-badge">
                            {audits.length}
                        </Badge> */}

                    </Card.Header>

                    <Card.Body className="dashboard-panel-body">

                        {audits.length > 0 ? (

                            <div className="dashboard-items">

                                {audits.map((audit, index) => (

                                    <div
                                        className="dashboard-item audit-item"
                                        key={audit.AuditID || index}
                                    >

                                        <div className="dashboard-item-icon">
                                            <i className="bi bi-clipboard-check"></i>
                                        </div>

                                        <div className="dashboard-item-content">

                                            <div className="dashboard-item-top">

                                                <h6>
                                                    <i className="bi bi-pc-display me-1"></i>
                                                    {audit.ComputerName || "-"}
                                                </h6>

                                                <span className="dashboard-item-date">
                                                    {audit.AuditTime || "-"}
                                                </span>

                                            </div>

                                            <p>
                                                {audit.AuditInfo ||
                                                    "No audit information available"}
                                            </p>

                                        </div>

                                    </div>

                                ))}

                            </div>

                        ) : (

                            <div className="dashboard-empty">

                                <i className="bi bi-clipboard-x"></i>

                                <h6>No audits found</h6>

                                <span>
                                    No audit activity is available.
                                </span>

                            </div>

                        )}

                    </Card.Body>

                    <Card.Footer className="dashboard-panel-footer">

                        <button
                            type="button"
                            className="dashboard-view-more"
                            onClick={() => navigate("/computer")}
                        >
                            View More
                            <i className="bi bi-arrow-right"></i>
                        </button>

                    </Card.Footer>

                </Card>


                {/* ================= ISSUES ================= */}

                <Card className="dashboard-panel issue-panel mt-4">

                    <Card.Header className="dashboard-panel-header">

                        <div className="dashboard-title">

                            <div className="dashboard-title-icon issue-icon">
                                <i className="bi bi-bug-fill"></i>
                            </div>

                            <div>
                                <h5>Issues</h5>
                            </div>

                        </div>

                        {/* <Badge bg="danger" className="count-badge">
                            {issues.length}
                        </Badge> */}

                    </Card.Header>

                    <Card.Body className="dashboard-panel-body">

                        {issues.length > 0 ? (

                            <div className="dashboard-items">

                                {issues.map((issue, index) => (

                                    <div
                                        className="dashboard-item issue-item"
                                        key={issue.issue_id || index}
                                    >

                                        <div className="dashboard-item-icon">
                                            <i className="bi bi-exclamation-triangle-fill"></i>
                                        </div>

                                        <div className="dashboard-item-content">

                                            <div className="dashboard-item-top">

                                                <h6>
                                                    {issue.title || "Untitled Issue"}
                                                </h6>

                                                <Badge
                                                    bg={
                                                        issue.priority === "Urgent"
                                                            ? "danger"
                                                            : issue.priority === "High"
                                                                ? "warning"
                                                                : issue.priority === "Medium"
                                                                    ? "primary"
                                                                    : "success"
                                                    }
                                                    className="priority-badge"
                                                >
                                                    {issue.priority || "Low"}
                                                </Badge>

                                            </div>

                                            <div className="dashboard-item-computer">

                                                <i className="bi bi-pc-display me-1"></i>

                                                {issue.ComputerName || "-"}

                                            </div>

                                            <span className="dashboard-item-date">
                                                {issue.created_date || "-"}
                                            </span>

                                        </div>

                                    </div>

                                ))}

                            </div>

                        ) : (

                            <div className="dashboard-empty">

                                <i className="bi bi-check-circle"></i>

                                <h6>No issues found</h6>

                                <span>
                                    All computers are currently clear.
                                </span>

                            </div>

                        )}

                    </Card.Body>

                    <Card.Footer className="dashboard-panel-footer">

                        <button
                            type="button"
                            className="dashboard-view-more"
                            onClick={() => navigate("/issues")}
                        >
                            View More
                            <i className="bi bi-arrow-right"></i>
                        </button>

                    </Card.Footer>

                </Card>

            </Col>


            {/* =====================================================
                RIGHT COLUMN
                ALERTS + ROLLCALL
            ====================================================== */}

            <Col lg={6}>

                {/* ================= ALERTS ================= */}

                <Card className="dashboard-panel alerts-panel">

                    <Card.Header className="dashboard-panel-header">

                        <div className="dashboard-title">

                            <div className="dashboard-title-icon alert-icon">
                                <i className="bi bi-bell-fill"></i>
                            </div>

                            <div>
                                <h5>Alerts</h5>
                            </div>

                        </div>

                        {/* <Badge bg="warning" className="count-badge">
                            {alerts.length}
                        </Badge> */}

                    </Card.Header>

                    <Card.Body className="dashboard-panel-body">

                        {alerts.length > 0 ? (

                            <div className="alerts-grid">

                                {alerts.map((alert, index) => (

                                    <DashboardAlertCard
                                        key={alert.ContentId || index}
                                        content={alert.Content_String}
                                        createdDate={alert.CreatedDate}
                                    />

                                ))}

                            </div>

                        ) : (

                            <div className="dashboard-empty">

                                <i className="bi bi-bell-slash"></i>

                                <h6>No alerts</h6>

                                <span>
                                    There are no system alerts.
                                </span>

                            </div>

                        )}

                    </Card.Body>

                    <Card.Footer className="dashboard-panel-footer">

                        <button
                            type="button"
                            className="dashboard-view-more"
                            onClick={() => navigate("/notification")}
                        >
                            View More
                            <i className="bi bi-arrow-right"></i>
                        </button>

                    </Card.Footer>

                </Card>


                {/* ================= ROLLCALL ================= */}

                <Card
                    className="dashboard-panel website-card mt-4"
                    onClick={() =>
                        window.open(
                            "https://rollcall.enminvithaigal.in/",
                            "_blank"
                        )
                    }
                >

                    <Card.Body className="website-card-body">

                        <div className="website-card-icon">
                            <i className="bi bi-globe2"></i>
                        </div>

                        <div className="website-card-content">

                            <h5>Visit RollCall</h5>

                            <p>
                                Monitor the server perfomances.
                            </p>

                        </div>

                        <div className="website-card-arrow">
                            <i className="bi bi-shield-shaded"></i>
                        </div>
                        <button
                            type="button"
                            className="dashboard-view-more"
                        >
                            <i className="bi bi-arrow-right"></i>
                        </button>

                    </Card.Body>

                </Card>

            </Col>

        </Row>
        </>
        ) : (
             <>
                    {/* ================= EMPLOYEE ================= */}

                    <ComputerPage />

                </>
        )}
        </div>
        
    );
};


const mapStateToProps = (state) => ({
    audits: state.dashboard.audits || [],
    issues: state.dashboard.issues || [],
    alerts: state.dashboard.alerts || [],
    isAdmin: state.profile.RoleID == "1" ? true : false,
    isUser: state.profile.RoleID == "2" ? true : false
});


const mapDispatchToProps = {
    getDashboardAudits,
    getDashboardIssues,
    getDashboardAlerts
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Dashboard);

